import React from 'react';

import '../styles/passwordreset.css';

function PasswordReset (props) {

    return (
        <div className='passwordreset'>This is password reset page </div>
    );

};

export default PasswordReset